import { render } from "./SubDmd.vue?vue&type=template&id=313a6c9e&scoped=true"
import script from "./SubDmd.vue?vue&type=script&lang=js"
export * from "./SubDmd.vue?vue&type=script&lang=js"

import "./SubDmd.vue?vue&type=style&index=0&id=313a6c9e&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313a6c9e"]])

export default __exports__